import { render, staticRenderFns } from "./EditRecord.vue?vue&type=template&id=334bb47a&"
import script from "./EditRecord.vue?vue&type=script&lang=js&"
export * from "./EditRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports